module.exports = __webpack_public_path__ + "img/cargate.ccc96be7.svg";